import { z } from "zod";

const appEnv = z.enum(["msw", "local", "stg", "prod"]);

const schema = z.object({
    PUBLIC_APP_ENV: appEnv.default("local"),
    PUBLIC_DEMO: z.stringbool().default(false),
    PUBLIC_API_URL: z.string().url(),
    PUBLIC_AUTH_SERVICE_URL: z.string().url(),
    PUBLIC_AUTH_LOGIN_URL: z.string().url(),
    PUBLIC_OFFICEVIBE_RECOGNITION_URL: z.string().url(),
    PUBLIC_PINGBOARD_URL: z.string().url(),
    PUBLIC_LAUNCH_DARKLY_CLIENT_ID: z.string().min(1).optional(),
    PUBLIC_LAUNCH_DARKLY_USE_REMOTE_FLAGS_FOR_LOCAL_AND_MSW: z.stringbool().default(false),
    PUBLIC_SKIP_ONBOARDING_TOUR: z.stringbool().default(false),
    PUBLIC_LOGROCKET_APP_ID: z.string().min(1).optional(),
    PUBLIC_INTERCOM_APP_ID: z.string().min(1).optional(),
    PUBLIC_WORKLEAP_CLASSIC_URL: z.string().url().default("https://management.workleap-stg.com"),
    PUBLIC_WORKLEAP_PERFORMANCE_URL: z.string().url().default("https://performance.workleap-stg.com"),
    PUBLIC_WORKLEAP_AI_URL: z.string().url().default("https://ai.workleap-stg.com"),
    PUBLIC_OFFICEVIBE_URL: z.string().url().default("https://officevibe.workleap-stg.com"),
    PUBLIC_COMPENSATION_URL: z.string().url().default("https://compensation.workleap-stg.com")
});

export const env = schema.parse({
    PUBLIC_APP_ENV: process.env.PUBLIC_APP_ENV,
    PUBLIC_DEMO: process.env.PUBLIC_DEMO,
    PUBLIC_API_URL: process.env.PUBLIC_API_URL,
    PUBLIC_AUTH_SERVICE_URL: process.env.PUBLIC_AUTH_SERVICE_URL,
    PUBLIC_AUTH_LOGIN_URL: process.env.PUBLIC_AUTH_LOGIN_URL,
    PUBLIC_OFFICEVIBE_RECOGNITION_URL: process.env.PUBLIC_OFFICEVIBE_RECOGNITION_URL,
    PUBLIC_PINGBOARD_URL: process.env.PUBLIC_PINGBOARD_URL,
    PUBLIC_LAUNCH_DARKLY_CLIENT_ID: process.env.PUBLIC_LAUNCH_DARKLY_CLIENT_ID,
    PUBLIC_LAUNCH_DARKLY_USE_REMOTE_FLAGS_FOR_LOCAL_AND_MSW: process.env.PUBLIC_LAUNCH_DARKLY_USE_REMOTE_FLAGS_FOR_LOCAL_AND_MSW,
    PUBLIC_SKIP_ONBOARDING_TOUR: process.env.PUBLIC_SKIP_ONBOARDING_TOUR,
    PUBLIC_LOGROCKET_APP_ID: process.env.PUBLIC_LOGROCKET_APP_ID,
    PUBLIC_INTERCOM_APP_ID: process.env.PUBLIC_INTERCOM_APP_ID,
    PUBLIC_WORKLEAP_CLASSIC_URL: process.env.PUBLIC_WORKLEAP_CLASSIC_URL,
    PUBLIC_WORKLEAP_PERFORMANCE_URL: process.env.PUBLIC_WORKLEAP_PERFORMANCE_URL,
    PUBLIC_WORKLEAP_AI_URL: process.env.PUBLIC_WORKLEAP_AI_URL,
    PUBLIC_OFFICEVIBE_URL: process.env.PUBLIC_OFFICEVIBE_URL,
    PUBLIC_COMPENSATION_URL: process.env.PUBLIC_COMPENSATION_URL
});

export type AppEnvironmentValue = z.infer<typeof appEnv>;
